import request from "graphql-request";
import {
  createAppointmentMutation,
  deleteAppointmentMutation,
  updateAppointmentMutation,
} from "../graphQL/graphMutation";
import BASEURL from "../../pages/Utils/Baseurl";

export const addAppoinmentService = async (values) => {
  let createStatus = false;
  let errormessage;
  try {
    const res = await request(BASEURL, createAppointmentMutation, {
      input: {
        ...values,
      },
    });
    createStatus = true;
  } catch (err) {
    console.error(err.message, "addAppoinmentService error");
    errormessage=err.response?.errors?.[0]?.message;
  }

  return {createStatus,errormessage};
};

export const updateAppointmentService = async (values, id) => {
  let updateStatus = false;
  let errormessage;
  try {
    const res = await request(BASEURL, updateAppointmentMutation, {
      input: {
        id: id,
        ...values,
      },
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.message, "updateAppointmentService error");
    errormessage=err.response?.errors?.[0]?.message;
    updateStatus = false;
  }

  return  {updateStatus,errormessage};
};

export const deleteAppointmentService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, deleteAppointmentMutation, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "deleteAppointmentService error");
    delteStatus = false;
  }
  return delteStatus;
};
